import { host } from '@branding/config';
import { QuestionResponse } from '@/types/QuestionTypes';
import { useAnalytics } from '@hooks/useAnalytics';
import { fetchWithRetry } from '@/network';
import { usePostHog } from 'posthog-js/react';

interface Params {
	answerBody: any;
}

export const useQueryAnswerQuestion = () => {
	const { trackRefineEvent } = useAnalytics();
	const posthog = usePostHog();
	const sessionID = posthog?.get_session_id();

	const postAnswerQuestion = async ({ answerBody }: Params): Promise<QuestionResponse | null> => {
		const url = new URL(`${host}/api/branchAnswerQuestion`);

		return fetchWithRetry<QuestionResponse>(
			url.toString(),
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Refine-Sessionid': sessionID,
				},
				body: JSON.stringify(answerBody),
			},
			{
				endpoint: 'branchAnswerQuestion',
				analytics: { trackRefineEvent },
			},
		);
	};

	return { postAnswerQuestion };
};
